import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import LayoutFullScreenOverlay from "@/ui/layouts/LayoutFullScreenOverlay";
import LayoutFillParentCentered from "@/ui/layouts/LayoutFillParentCentered";
import { ViewCoAUpload } from "@/ui/compositionRootUI";

export const CoAUploadOverlay: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { coaId } = useParams() as { coaId: string };

    const handleOverlayClick = () => {
        const basePath = location.pathname.split("/upload")[0];
        if (typeof basePath === "string") {
            navigate(basePath);
        }
    };

    return (
        <LayoutFullScreenOverlay
            backgroundColor={"var(--proda-black)"}
            opacity={0.8}
            onClick={handleOverlayClick}
        >
            <LayoutFillParentCentered>
                <ViewCoAUpload
                    coaId={coaId ? parseInt(coaId) : null}
                    LayoutBoxCenteredProps={{
                        onClick: e => e.stopPropagation(),
                    }}
                    sx={{ width: "100%" }}
                />
            </LayoutFillParentCentered>
        </LayoutFullScreenOverlay>
    );
};
